import {
  GET_FAQ_CATEGORIES,
  GET_FAQ_REQUEST_PENDING,
  GET_FAQ_REQUEST_SUCCESS,
  GET_FAQ_REQUEST_ERROR,
  CHANGE_FAQ_REQUEST_PENDING,
  CHANGE_FAQ_REQUEST_SUCCESS,
  CHANGE_FAQ_REQUEST_ERROR,
} from '../types/faq'

const initialState = {
  categories: [],
  isGetLoading: false,
  isChangeLoading: false,
  errors: [],
}

const faq = (state = initialState, action) => {
  switch (action.type) {
    case GET_FAQ_CATEGORIES:
      return { ...state, categories: action.payload || [] }

    case GET_FAQ_REQUEST_PENDING:
      return { ...state, isGetLoading: true }

    case GET_FAQ_REQUEST_SUCCESS:
      return { ...state, errors: [], isGetLoading: false }

    case GET_FAQ_REQUEST_ERROR:
      return { ...state, errors: action.payload, isGetLoading: false }

    case CHANGE_FAQ_REQUEST_PENDING:
      return { ...state, isChangeLoading: true }

    case CHANGE_FAQ_REQUEST_SUCCESS:
      return { ...state, errors: [], isChangeLoading: false }

    case CHANGE_FAQ_REQUEST_ERROR:
      return { ...state, errors: action.payload, isChangeLoading: false }

    default:
      return state
  }
}

export default faq
